import * as React from "react";
export default class LiquorImg extends React.Component {
    constructor(props) {
        super(props);
        this.handleError = () => {
            this.setState({ src: "/img/NotAvail.png" });
        };
        this.state = {
            src: this.props.src
        };
    }
    componentWillReceiveProps(newProps) {
        this.setState({ src: newProps.src });
    }
    render() {
        return (React.createElement("img", { alt: "pic", src: this.state.src, onError: this.handleError }));
    }
}
;
//# sourceMappingURL=liquor-img.js.map